import moment from "moment";

import { FormProps } from "../../framework/react/FormProvider";
import { useFormDialog } from "../components/FormDialog";
import { PageFormItem, GroupFormItem, InfoFormItem, NoticeFormItem } from "../components";
import { CreateAppointmentBranch, createCreateAppointmentBranch } from "./appointment-task-dialog";

export enum CreateAppointmentFormIds {
    DatePickerDate = "date-picker-date",
    TextAreaDescription = "text-area-description",
}

export type CreateAppointmentForm =
    GroupFormItem<Array<
        | WarningPage
        | CreateAppointmentBranch
    >>

type WarningPage = PageFormItem<GroupFormItem<[NoticeFormItem, InfoFormItem]>>;

export const useCreateAppointmentDialog = (now: string, onConfirm: FormProps<CreateAppointmentForm>["onSubmit"]) => {
    const today = moment(now).startOf("day").toISOString(true);

    const createAppointmentBranch = createCreateAppointmentBranch(today, {
        datePickerAppointmentDate: CreateAppointmentFormIds.DatePickerDate,
        textAreaAppointmentDescription: CreateAppointmentFormIds.TextAreaDescription,
    });

    const pages = [];
    pages.push(createAppointmentBranch);

    const form: CreateAppointmentForm = {
        type: "group",
        render: "all at once",
        items: pages,
    };

    return useFormDialog(form, onConfirm);
};
